export default __webpack_public_path__ + "static/media/dialog-action.8a871279.svg";